// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__0euCn","formWidthContainer":"Login_formWidthContainer__9Rfay","oinq":"Login_oinq__74Eiz","oinqIn":"Login_oinqIn__o9cr1"};